import styled, { css } from 'styled-components'

const tableReset = css`
  width: auto;
  height: auto;
  margin: 0;
  padding: 0;
  border: none;
  border-collapse: inherit;
  border-spacing: 0;
  border-color: inherit;
  text-align: left;
  font-weight: inherit;
  -webkit-border-horizontal-spacing: 0;
  -webkit-border-vertical-spacing: 0;
`

export const TableHeaderStyle = styled.tr`
  ${tableReset};
  padding-bottom: 8px;
`

export const TableHead = styled.thead`
  ${tableReset};
`

export const TableHeaderCell = styled.th(
  ({ theme }) => css`
    ${tableReset};

    /* 16px (8px + 8px) because TableHeader don't show margin */
    padding: 8px 12px 16px;
    line-height: 1.2;

    text-transform: uppercase;
    transition: color 125ms ease-in-out;
    user-select: none;

    font-size: ${theme.fontSizes.tiny};
    font-weight: ${theme.fontWeights.semibold};
    color: ${theme.colors.foreground.secondary[3]};

    :hover {
      color: ${theme.colors.foreground.secondary[1]};
    }
  `
)

export const TableCell = styled.td(
  ({ theme }) => css`
    ${tableReset};

    padding: 12px 0px 12px 12px;
    line-height: 1.4;

    font-size: ${theme.fontSizes.smaller};
    font-weight: ${theme.fontWeights.regular};
    color: ${theme.colors.foreground.secondary[4]};
  `
)

export const TableRow = styled.tr`
  ${tableReset};
  border-radius: ${({ theme }) => theme.radii.large};

  /* Animate the background change */
  transition: background 250ms ease-in-out;

  ${/* sc-selector */ TableCell}:nth-child(1) {
    border-top-left-radius: ${({ theme }) => theme.radii.large};
    border-bottom-left-radius: ${({ theme }) => theme.radii.large};
  }

  ${/* sc-selector */ TableCell}:nth-last-child(1) {
    padding-right: 12px;
    border-top-right-radius: ${({ theme }) => theme.radii.large};
    border-bottom-right-radius: ${({ theme }) => theme.radii.large};
  }
`

export const TableBody = styled.tbody`
  ${tableReset};
`

interface TableProps {
  $evenColumns?: boolean
  $hideHeader?: boolean
}

export const TableStyle = styled.table<TableProps>`
  ${tableReset};

  ${({ $evenColumns }) =>
    $evenColumns &&
    css`
      table-layout: fixed;
      width: 100%;
    `}

  ${({ $hideHeader }) =>
    $hideHeader &&
    css`
      ${TableHead} {
        visibility: collapse;
      }
    `}

  ${/* sc-selector */ TableRow} {
    :nth-child(odd) {
      background-color: ${({ theme }) => theme.colors.background.secondary[2]};
      z-index: -1; /* Fix for scrollbar going under odd rows */
    }

    :hover {
      background-color: ${({ theme }) => theme.colors.state.hover};
    }
  }
`
